import VueRouter, { RouteConfig } from 'vue-router'
const Index = () => import('../views/ai-test/Index.vue')
const ListPage = () => import('../views/ai-test/StuTestListPage.vue')
const AllListPage = () => import('../views/ai-test/StuAllTestListPage.vue')
const AddPage = () => import('../views/ai-test/StuTestAddPage.vue')
const StuReport = () => import('../views/ai-test/StuReportDetail.vue')

export const aiTestRoute: RouteConfig = {
  path: '/ai-test-home',
  name: 'ai_test_home',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '体质画像',
  },
}

export const stuAiTestListRoute: RouteConfig = {
  path: '/ai-test-list',
  name: 'ai_test_list',
  component: ListPage,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: 'AI模拟测试',
  },
}

export const stuAllTestListRoute: RouteConfig = {
  path: '/all-test-list',
  name: 'all_test_list',
  component: AllListPage,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: 'AI模拟测试',
  },
}

export const stuTestAddRoute: RouteConfig = {
  path: '/ai-test-add',
  name: 'ai_test_add',
  component: AddPage,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '布置AI模拟体测',
  },
}

export const stuTestReportDetailRoute: RouteConfig = {
  path: '/ai-test-student-report-detail',
  name: 'ai_test_student_report_detail',
  component: StuReport,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: 'AI体测学生报告',
  },
}
export default [aiTestRoute, stuAiTestListRoute, stuAllTestListRoute, stuTestAddRoute, stuTestReportDetailRoute]

export function navigateToAITest(router: VueRouter) {
  router.push({ name: aiTestRoute.name })
}
